export const shouldLoad = () => document.querySelector('[data-controller="gallery-section"]') !== undefined;